import React from 'react';
import Header from '../component/Header';
import Footer from '../component/footer';
import { MousePointer2, PlaySquare, Download } from 'lucide-react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';


const Login = () => {
  return (
    <>
      <Seo
        title="Web Development & Digital Skills | LearnWebAcademy"
        description="Learn web development with beginner-friendly online courses, expert guidance, and practical lessons to build websites confidently with ease now!"
        canonicalPath="/"
        schema={{
          '@context': 'https://schema.org',
          '@graph': [
            {
              '@type': 'Organization',
              '@id': 'https://learnwebacademy.net/#organization',
              name: 'LearnWebAcademy',
              url: 'https://learnwebacademy.net',
              logo: 'https://learnwebacademy.net/LOGO-web-academy.svg',
            },
            {
              '@type': 'WebSite',
              '@id': 'https://learnwebacademy.net/#website',
              name: 'LearnWebAcademy',
              url: 'https://learnwebacademy.net',
              publisher: {
                '@id': 'https://learnwebacademy.net/#organization',
              },
            },
            {
              '@type': 'EducationalOrganization',
              '@id': 'https://learnwebacademy.net/#educational-organization',
              name: 'LearnWebAcademy',
              url: 'https://learnwebacademy.net',
              logo: 'https://learnwebacademy.net/LOGO-web-academy.svg',
              description: 'Beginner-friendly online web development courses, expert guidance, and practical lessons.',
            },
            {
              '@type': 'WebPage',
              '@id': 'https://learnwebacademy.net/#webpage',
              url: 'https://learnwebacademy.net/',
              name: 'Web Development & Digital Skills | LearnWebAcademy',
              description: 'Learn web development with beginner-friendly online courses, expert guidance, and practical lessons to build websites confidently with ease now!',
              isPartOf: {
                '@id': 'https://learnwebacademy.net/#website',
              },
              about: {
                '@id': 'https://learnwebacademy.net/#educational-organization',
              },
            },
          ],
        }}
      />
      <Header />

    <main>
        {/* HERO SECTION */}
        <section className="bg-[#113A28] text-white pt-32 pb-40 px-6 md:px-12 relative rounded-b-[3rem] md:rounded-b-[5rem]">
          {/* Background decoration */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20">
            <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-full">
               <path d="M0,50 C30,80 70,20 100,50 L100,100 L0,100 Z" fill="none" stroke="white" strokeWidth="0.5" />
               <path d="M0,70 C40,90 60,30 100,60 L100,100 L0,100 Z" fill="none" stroke="white" strokeWidth="0.5" />
            </svg>
          </div>

          <div className="relative z-10 grid items-center grid-cols-1 gap-12 mx-auto max-w-7xl md:grid-cols-2">
            {/* Left Content */}
            <div className="space-y-6">
             
              <h1 className="text-5xl font-bold leading-tight md:text-6xl">
                Learn To Make Websites<br />
                <span className="text-[#4CE470]"> With Confidence.</span> <br />
              
              </h1>
        
              
              <div className="flex flex-col gap-4 pt-4 sm:flex-row">
                 <Link
                              to="/login?mode=signup"
                            >
                <button className="bg-[#4CE470] text-[#113A28] px-8 py-3 rounded-lg font-bold text-sm flex items-center justify-center gap-2 hover:bg-[#3bc45d]">
                  GET STARTED NOW
                </button>

                </Link>
            
              </div>
            </div>

            {/* Right Content (Mock UI from original design) */}
            <div className="relative mt-10 md:mt-0">
              <div className="relative p-4 border shadow-2xl bg-white/10 backdrop-blur-lg border-white/20 rounded-2xl">
                {/* Main Video Area Placeholder */}
                <div className="bg-gray-800 h-[250px] md:h-[300px] rounded-lg relative overflow-hidden flex items-center justify-center">
                  <img src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&q=80&w=600" alt="Learning" width="600" height="300" className="object-cover w-full h-full opacity-80" />
                  
                  {/* Floating Elements inside video */}
                 
                </div>

                {/* Bottom Thumbnails */}
                <div className="grid grid-cols-4 gap-2 mt-2">
                  {[1,2,3,4].map((i) => (
                    <div key={i} className="h-16 overflow-hidden bg-gray-700 rounded-lg">
                      <img src={`https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=200&q=80`} alt="Participant" width="200" height="64" className="object-cover w-full h-full transition-opacity cursor-pointer opacity-70 hover:opacity-100"/>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* BRIDGING THE GAP SECTION -> Repurposed for "Affordable Learning" */}
        <section className="px-6 py-24 mx-auto md:px-12 max-w-7xl">
          <div className="grid items-center grid-cols-1 gap-16 md:grid-cols-2">
            {/* Image Collage Mockup (Kept from original design) */}
            <div className="relative">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-4">
                  <img src="https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=400" alt="Study 1" width="400" height="192" className="object-cover w-full h-48 shadow-lg rounded-2xl" />
                  <img src="https://images.unsplash.com/photo-1516321497487-e288fb19713f?auto=format&fit=crop&w=400" alt="Study 2" width="400" height="128" className="object-cover w-full h-32 shadow-lg rounded-2xl" />
                </div>
                <div className="pt-8 space-y-4">
                  <img src="https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=400" alt="Study 3" width="400" height="128" className="object-cover w-full h-32 shadow-lg rounded-2xl" />
                  <img src="https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&w=400" alt="Study 4" width="400" height="192" className="object-cover w-full h-48 shadow-lg rounded-2xl" />
                </div>
              </div>
            </div>

            {/* Text Content */}
            <div className="space-y-6">
              <span className="inline-block border border-gray-200 text-gray-600 rounded-lg px-4 py-1.5 text-xs font-semibold">
                About us
              </span>
              <h2 className="text-4xl font-bold text-[#113A28] leading-tight">
                LearnWebAcademy was built to help beginners and intermediate users break through learning plateaus.<br />
              </h2>
              <p className="max-w-md text-sm leading-relaxed text-gray-500">
         Our bite-sized lessons and progressive curriculum make tough concepts feel manageable. Our teaching style is focused on clarity, with just enough repetition to help key concepts stick without becoming boring.
              </p>
              
              {/* Replacing the 2 stats with your 4 stats from your code */}
  
            </div>
          </div>
        </section>

{/* WHAT WE OFFER SECTION (Redesigned Asymmetric Layout) */}
        <section className="py-24 px-6 md:px-12 bg-[#F8F9FA] relative overflow-hidden">
          {/* Decorative faint background lines */}
          <div className="absolute inset-0 opacity-50 pointer-events-none">
            <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
              <path d="M-100 200 Q 400 50 800 300 T 2000 100" fill="none" stroke="#4CE470" strokeWidth="0.5" strokeDasharray="10 10" />
              <path d="M-100 600 Q 500 800 1000 400 T 2000 700" fill="none" stroke="#113A28" strokeWidth="0.5" strokeOpacity="0.2" />
            </svg>
          </div>

          <div className="relative z-10 max-w-6xl mx-auto">
            {/* Header */}
            <div className="mb-24 text-center">
              <span className="inline-block border border-gray-200 text-gray-600 rounded-lg px-4 py-1.5 text-xs font-semibold">
                Our Services
              </span>
            </div>

            <div className="relative flex flex-col gap-20 md:gap-32">
              {/* Vertical connecting line for desktop */}
              <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-[1px] bg-gradient-to-b from-transparent via-gray-300 to-transparent -translate-x-1/2 -z-10"></div>

              {/* Block 1: Great Resources (Image Left, Text Right) */}
              <div className="flex flex-col items-center gap-10 md:flex-row md:gap-20">
                <div className="relative w-full md:w-1/2">
                  <img 
                    src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80" 
                    alt="Great resources" 
                    width="800"
                    height="300"
                    className="rounded-3xl shadow-xl w-full h-[300px] object-cover"
                  />
                  {/* Floating Badge */}
                 
                </div>
                <div className="w-full md:w-1/2">
                  <h3 className="text-3xl font-bold text-[#113A28] mb-4">Great resources</h3>
                  <p className="max-w-md text-lg leading-relaxed text-gray-600">
                    Get access to curated learning materials to support your growth.
                  </p>
                </div>
              </div>

              {/* Block 2: Various Topics (Text Left, Image Right) */}
              <div className="flex flex-col items-center gap-10 md:flex-row-reverse md:gap-20">
                <div className="relative w-full md:w-1/2">
                  <img 
                    src="https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=800&q=80" 
                    alt="Various topics" 
                    width="800"
                    height="300"
                    className="rounded-3xl shadow-xl w-full h-[300px] object-cover"
                  />
                  {/* Floating Badge */}
                  
                </div>
                <div className="flex flex-col items-start w-full md:w-1/2 md:text-right md:items-end">
                  <h3 className="text-3xl font-bold text-[#113A28] mb-4">Various topics</h3>
                  <p className="max-w-md text-lg leading-relaxed text-gray-600">
                    Choose lessons based on your knowledge, needs, and skills.
                  </p>
                </div>
              </div>

              {/* Block 3: Excellent Results (Image Left, Text Right) */}
              <div className="flex flex-col items-center gap-10 md:flex-row md:gap-20">
                <div className="relative w-full md:w-1/2">
                  <img 
                    src="https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=800&q=80" 
                    alt="Excellent results" 
                    width="800"
                    height="300"
                    className="rounded-3xl shadow-xl w-full h-[300px] object-cover"
                  />
                  {/* Floating Badge */}
                  
                </div>
                <div className="w-full md:w-1/2">
                  <h3 className="text-3xl font-bold text-[#113A28] mb-4">Excellent results</h3>
                  <p className="max-w-md mb-8 text-lg leading-relaxed text-gray-600">
                    Achieve your goals with expert-led, effective training.
                  </p>

                  <Link to="/login?mode=signup">

                  <button className="bg-[#113A28] text-white px-8 py-4 rounded-lg font-bold text-sm hover:bg-[#1a573c] transition-colors shadow-lg shadow-gray-300">
                    START LEARNING NOW
                  </button>
                  </Link>
                </div>
              </div>

            </div>
          </div>
        </section>
        
      {/* =========================================
{/* =========================================
     {/* =========================================
            TYPEBOT-STYLE "HOW IT WORKS" SECTION 
        ========================================= */}
        <section className="px-6 py-24 md:px-12">
          <div className="mx-auto max-w-7xl">
            {/* Header matches the Typebot left-aligned style */}
           <div className='mb-24 text-center'>
            <h2 className="inline-block border border-gray-200 text-gray-600 rounded-lg px-4 py-1.5 text-xs font-semibold">
              How It Works
            </h2>
</div>
            {/* 3-Column Grid for the features */}
            <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
              
              {/* STEP 1: Create an account */}
              <div className="bg-white rounded-[24px] p-3 shadow-sm border border-gray-200/60 hover:shadow-xl transition-shadow duration-300 flex flex-col">
                {/* Graphic Container with Glowing Gradient */}
                <div className="bg-[#113A28] w-full h-[240px] rounded-[18px] relative overflow-hidden flex items-center justify-center">
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-56 h-56 bg-[#4CE470] rounded-lg blur-[70px] opacity-40"></div>
                  
                  {/* Mock UI: Sign Up Button */}
                  <div className="relative z-10 bg-[#4CE470] text-[#113A28] font-bold px-8 py-3 rounded-lg shadow-[0_0_20px_rgba(76,228,112,0.4)] transition-transform hover:scale-105 cursor-pointer">
                    Create account
                  </div>
                  {/* Mock Cursor */}
                  <MousePointer2 className="absolute z-20 mt-16 ml-32 text-white transform fill-white w-7 h-7 -rotate-12 drop-shadow-lg" />
                </div>
                
                {/* Text Content */}
                <div className="flex-1 p-6 pt-8">
                  <p className="text-xs font-bold text-[#113A28] uppercase tracking-wider mb-3">Step 1</p>
                  <h3 className="mb-3 text-xl font-bold text-gray-900">Create an account</h3>
                  <p className="text-sm leading-relaxed text-gray-500">
                    Quick signup unlocks access to the full course library.
                  </p>
                </div>
              </div>

              {/* STEP 2: Dive into Courses */}
              <div className="bg-white rounded-[24px] p-3 shadow-sm border border-gray-200/60 hover:shadow-xl transition-shadow duration-300 flex flex-col">
                {/* Graphic Container with Course Dashboard Mockup */}
                <div className="bg-[#113A28] w-full h-[240px] rounded-[18px] relative overflow-hidden flex items-center justify-center p-6">
                  <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#4CE470] rounded-lg blur-[80px] opacity-20"></div>
                  
                  {/* Mock UI: Course Interface */}
                  <div className="relative z-10 w-full h-full bg-[#0A1F15] rounded-lg border border-white/10 shadow-2xl flex flex-col p-4 gap-3">
                    <div className="w-1/3 h-2.5 bg-white/20 rounded-lg"></div>
                    <div className="flex h-full gap-3 mt-1">
                      <div className="w-1/2 h-full border rounded-lg bg-white/5 border-white/5"></div>
                      <div className="w-1/2 h-full bg-[#4CE470]/10 rounded-lg border border-[#4CE470]/30 relative flex items-center justify-center">
                        <PlaySquare className="text-[#4CE470] opacity-80 w-8 h-8" />
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Text Content */}
                <div className="flex-1 p-6 pt-8">
                  <p className="text-xs font-bold text-[#113A28] uppercase tracking-wider mb-3">Step 2</p>
                  <h3 className="mb-3 text-xl font-bold text-gray-900">Dive into Courses</h3>
                  <p className="text-sm leading-relaxed text-gray-500">
                    Choose your level and follow beginner-to-pro tracks.
                  </p>
                </div>
              </div>

              {/* STEP 3: Download Anytime */}
              <div className="bg-white rounded-[24px] p-3 shadow-sm border border-gray-200/60 hover:shadow-xl transition-shadow duration-300 flex flex-col">
                {/* Graphic Container with Glowing Gradient */}
                <div className="bg-[#113A28] w-full h-[240px] rounded-[18px] relative overflow-hidden flex items-center justify-center">
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-56 h-56 bg-[#4CE470] rounded-lg blur-[70px] opacity-30"></div>
                  
                  {/* Mock UI: Download Button */}
                  <div className="relative z-10 bg-[#2A2A2A] border border-white/10 text-white font-bold px-8 py-3 rounded-lg shadow-2xl flex items-center gap-2 transition-transform hover:scale-105 cursor-pointer">
                    <Download size={20} className="text-[#4CE470]" />
                    Download
                  </div>
                  <MousePointer2 className="absolute z-20 mt-16 ml-32 text-white transform fill-white w-7 h-7 -rotate-12 drop-shadow-lg" />
                </div>
                
                {/* Text Content */}
                <div className="flex-1 p-6 pt-8">
                  <p className="text-xs font-bold text-[#113A28] uppercase tracking-wider mb-3">Step 3</p>
                  <h3 className="mb-3 text-xl font-bold text-gray-900">Download Anytime</h3>
                  <p className="text-sm leading-relaxed text-gray-500">
                    Access your lessons anywhere, even without a connection.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>


      
      </main>

        <Footer />
    </>
  );
};

export default Login;
